<template>
    <v-container fluid class="main-container d-flex flex-column pa-4">
        <v-card class="d-flex flex-column flex-grow-1">
            <v-card-title class="d-flex align-center justify-center">
                <v-icon :icon="icons.mdiCog" class="ma-2" />
                <span class="font-weight-black ma-2">{{ $t('menu.configurations') }}</span>
                <v-spacer />
                <v-btn class="align-center mr-2" color="secondary" density="default" rounded="rounded-md"
                    @click="createConfiguration" :prepend-icon="icons.mdiPlus">{{ $t('action.newConfiguration') }}</v-btn>
            </v-card-title>

            <v-divider />

            <v-row fill-height>
                <v-col fill-height>
                    <v-container fluid class="pa-0 fill-height d-flex flex-column">
                        <AgGrid class="flex-grow-1" :fetchUrl="fetchUrl" :columnDefs="columnDefs" :gridParams="gridParams" :domLayout="domLayout" />
                    </v-container>
                </v-col>
            </v-row>
        </v-card>
    </v-container>

    <!-- Configuration Dialog -->
    <v-dialog v-model="configurationDialogVisible" fullscreen>
        <v-card>
            <v-card-text>
                <v-chip-group>
                    <v-chip>Chip one</v-chip>
                    <v-chip>Chip two</v-chip>
                    <v-chip>Chip three</v-chip>
                </v-chip-group>

                <AgGridDragDrop></AgGridDragDrop>
            </v-card-text>

            <v-divider />

            <v-card-actions class="justify-end">
                <v-btn variant="text" @click="configurationDialogVisible = false">{{ $t('action.cancel') }}</v-btn>
                <v-btn color="primary" variant="flat" @click="configurationDialogVisible = false">{{ $t('action.ok') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import AgGrid from '@/components/AgGrid.vue';
import AgGridDragDrop from '@/components/AgGridDragDrop.vue';
import { toast } from 'vue3-toastify';
import { inject, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useUserStore } from '@/stores/userStore';
import {
    mdiCog,
    mdiPlus,
} from '@mdi/js';

const urlWebAPI = inject('urlWebAPI');
const translate = inject('translate');

const route = useRoute();
const userStore = useUserStore();

const icons = {
    mdiCog,
    mdiPlus,
};

const domLayout = 'autoHeight';

const fetchUrl = 'GetConfigurations';
const columnDefs = [
    {
        field: 'name',
        headerName: translate('name', 'column'),
        rowGroup: true,
        hide: true
    },
    {
        field: 'fileName',
        headerName: translate('file', 'column'),
    },
    {
        field: 'customerName',
        headerName: translate('customer', 'column'),
    },
    {
        field: 'exportFileName',
        headerName: translate('exportFile', 'column'),
    },
    {
        field: 'parameters',
        headerName: translate('parameters', 'column'),
    },
    {
        field: 'credentials',
        headerName: 'Credentials'
    },
    {
        field: 'applicationDomainId',
        headerName: 'ApplicationDomainId'
    },
    {
        field: 'applicationId',
        headerName: 'ApplicationId'
    },
    {
        field: 'edit',
        headerName: '',
        type: 'editAction'
    },
];
const gridParams = {
    token: userStore.getUser().token,
    customerReference: (route.params.customerReference != 'undefined') ? route.params.customerReference : null,
};

const configurationData = ref(null);
const configurationDialogVisible = ref(false);
const configurationCreateMode = ref(false);
const configurationEditMode = ref(false);

function onCellClicked(params) {
    if (typeof params.data != 'undefined' && typeof params.colDef.field != 'undefined') {
        if (params.colDef.field == 'edit') {
            // EDIT CONFIGURATION
            if (window.location.pathname.toLocaleLowerCase().indexOf('configuration') > -1) {
                editConfiguration(params);
            }
        }
    }
}

function getConfigurations(params = null) {
    fetch(urlWebAPI + 'GetConfigurations')
        .then(result => result.json())
        .then(data => {
            configurationData.value = data;
        })
        .catch(error => {
            toast.error('Error during executing Configurations data.');
        });
}

function createConfiguration() {
    configurationCreateMode.value = true;
    configurationEditMode.value = false;
    configurationDialogVisible.value = true;
}

function editConfiguration(params) {
    configurationCreateMode.value = false;
    configurationEditMode.value = true;
    configurationDialogVisible.value = true;
}
</script>
